import { gradients } from "./semanticTokens";

/**
 * Surface recipes. Apply with `layerStyle="card"` etc.
 * card / cardMuted / cardHover — white card with hairline ring, sunken panel, hover lift
 * sidebar / hero — navy gradient surfaces with inverse text
 * glass — sticky header (pair with className="mbf-glass" for the no-backdrop-filter fallback)
 * sunkenBand — stepper band inside wizard modals
 */
export const layerStyles = {
  card: { bg: "surface.card", borderRadius: "lg", boxShadow: "sm" },
  cardMuted: { bg: "surface.sunken", borderRadius: "lg", boxShadow: "none" },
  cardHover: { bg: "surface.card", borderRadius: "lg", boxShadow: "md", transform: "translateY(-2px)" },
  sidebar: { bg: gradients.sidebar, color: "text.inverse" },
  hero: { bg: gradients.hero, color: "text.inverse", borderRadius: "xl" },
  glass: {
    bg: "rgba(255,255,255,0.86)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    borderBottom: "1px solid",
    borderColor: "border.default",
  },
  sunkenBand: {
    bg: "surface.sunken",
    borderTop: "1px solid",
    borderBottom: "1px solid",
    borderColor: "border.default",
  },
};
